import React from 'react';

const DefaultDataPlaceholder = () => {
  return <div>Required data is missing in the cart. Please ensure to go through the steps and try again.</div>;
};

export default DefaultDataPlaceholder;
